/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  styles.ts
 */

import { type Theme, css } from '@emotion/react'
import { Z_INDEX_FIXED } from '@zcode-ui/themes'

export const root = css`
  :root {
    --header-height: 70;
  }
`

export const homeButton = css`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 124px;

  svg {
    margin-left: -4px;
  }
`

export const navbar = css`
  position: relative;
  top: 0;
  right: 0;
  left: 0;
  z-index: ${Z_INDEX_FIXED};

  width: 100%;
  height: calc(1px * var(--header-height));

  font-family: var(--chakra-fonts-body);

  padding: 0 24px;
  border-bottom: 1px solid transparent;
`

export const transparentThemeNavbar = css`
  max-width: 100%;
  border: 0;
  box-shadow: none;
`

export const navbarContent = ({ colors, typography }: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  color: ${colors?.textLightest};

  font-weight: ${typography?.fontWeightLight};
`

export const hasMaxWidth = css`
  max-width: 1440px;
  margin: 0 auto;
`

export const fixedNavbar = css`
  position: fixed;
`
